<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cvi">
<div class="cover">
<p class="fig"><img alt="" height="750" src="images/eer-nicot04nu-cover.jpg" width="506"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-nicot04nu-0001.vue?1f9a4eb6